import React, { FC } from 'react';
import { Button, Modal } from '@/components/ui';
import classNames from 'classnames';
import Image from 'next/image';

import { TypeProduct } from '@/core/generated-types';
import { BUTTON_STYLES } from '@/components/ui/Buttons/utils';
import Heading, {
  HeadingTag,
  HeadingSize,
} from '@/components/ui/Heading/Heading';
import { ShopifyProduct, ShopifyVariant } from '@/lib/shopify';

interface ProductVariantModalProps {
  isOpen: boolean;
  handleClose: () => void;
  product: TypeProduct;
  addProduct: () => void;
  shopifyProductAddOn: ShopifyProduct | null;
  selectedVariant?: ShopifyVariant | null;
  setSelectedVariant?: (option: ShopifyVariant) => void;
}

const ProductVariantModal: FC<ProductVariantModalProps> = ({
  isOpen,
  handleClose,
  product,
  addProduct,
  shopifyProductAddOn,
  selectedVariant,
  setSelectedVariant,
}) => {
  const { shortTitle, shortDescription, addToCartText } = product.fields;
  const organicCottonBabyDollOptions = shopifyProductAddOn?.variants;

  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      modalClasses={{
        mobile: {
          top: 'auto',
          bottom: '0',
          minWidth: '100vw',
          maxHeight: '90dvh',
          transform: 'translateX(-50%)',
        },
      }}
      overlayClasses={{
        backgroundColor: 'rgba(59,59,59,.75)',
      }}
    >
      <div className="container max-w-sm">
        <Heading
          text={shortTitle}
          tag={HeadingTag.H3}
          size={HeadingSize.H3}
          classes="mb-4"
        />
        <p className="mb-2">{shortDescription}</p>
        <ul className="mb-4 flex align-middle">
          {organicCottonBabyDollOptions?.map((option) => {
            const { id, image, title } = option;
            const isOrganicCottonBabyDollSkinToneSelected =
              selectedVariant?.id === id;
            return (
              <li key={id} className="mr-2 w-[94px] text-center">
                <Image
                  src={image?.url}
                  height={94}
                  width={94}
                  alt={image?.altText || title}
                  className={classNames(
                    'cursor-pointer rounded border-[3px] border-solid',
                    isOrganicCottonBabyDollSkinToneSelected
                      ? 'border-indigo'
                      : 'border-grey-midtone',
                  )}
                  onClick={() => {
                    if (setSelectedVariant !== undefined) {
                      setSelectedVariant(option);
                    }
                  }}
                />
                <span className="text-sm capitalize">{title}</span>
              </li>
            );
          })}
        </ul>
        <Button
          ctaText={addToCartText || 'Add to Order'}
          onClick={() => {
            addProduct();
            handleClose();
          }}
          style={BUTTON_STYLES.primary}
          classes="w-full"
        />
      </div>
    </Modal>
  );
};

export default React.memo(ProductVariantModal);
